import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {CountryGetResponse} from '../../types/organization/country-get-response';
import {Country} from '../../types/country/country';
import {BaseRestService} from './BaseRestService';

@Injectable()
export class CountryRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('countries');
  }

  getAllCountries(withInapplicable: boolean = false): Observable<Country[]> {
    const params = {
      params: new HttpParams()
        .set('withInapplicable', String(withInapplicable))
    };
    return this.http.get<Country[]>(this.getEndpoint(), params);
  }

  search(size: number, page: number, name: string): Observable<CountryGetResponse> {
    const params = {
      params: new HttpParams()
        .set('size', String(size))
        .set('page', String(page))
        .set('name', name)
    };
    return this.http.get<CountryGetResponse>(this.getEndpoint(['search']), params);
  }

  getMembershops(): Observable<any> {
    return this.http.get<any>(this.getEndpoint(['membership-types']));
  }

  getInternationalDialingCode(countryId: number): Observable<string> {
    return this.http.get<string>(this.getEndpoint([String(countryId), 'phone-code']));
  }

  delete(countryId: number) {
    return this.http.delete(this.getEndpoint([String(countryId)]));
  }

  save(country: Country, image: File) {
    const formData: FormData = new FormData();

    if (image) {
      formData.append('file_data', image, image.name);
    }

    const dtoData = new Blob([JSON.stringify(country)], {
      type: 'application/json',
    });

    formData.append('country', dtoData);

    if (country.id) {
      return this.http.put<Country>(this.getEndpoint([String(country.id)]), formData);
    }

    return this.http.post<Country>(this.getEndpoint(), formData);
  }

}
